<template>
  <div>
    <validation-observer
      v-if="newRedirectUrlData"
      #default="{ handleSubmit }"
      ref="refFormObserver"
    >
      <div class="d-flex justify-content-between">
        <h4 class="mb-0 d-flex align-items-center">
          <font-awesome-icon class="mr-50" icon="fa-solid fa-file-lines" />
          <span class="ml-1">編輯外部連結</span>
        </h4>
      </div>
      <b-overlay
        :show="loading"
        spinner-variant="primary"
        spinner-type="grow"
        spinner-small
        rounded="sm"
      >
        <b-form class="mt-3" @submit.prevent="handleSubmit(onSubmit)">
          <div class="mt-2 mt-sm-3 position-relative">
            <b-row
              v-for="(redirect, index) in newRedirectUrlData.contents"
              :key="`redirect_${index}`"
              class="px-1"
            >
              <b-col
                cols="12"
                class="d-flex backgroundColor3 mb-1 radius-round border-1"
              >
                <b-row class="flex-grow-1 p-2">
                  <!-- product id -->
                  <b-col cols="12" md="3">
                    <b-form-group
                      :label="`圖示：`"
                      :label-for="`redirect_icon${index}`"
                      label-cols-md="3"
                    >
                      <v-select
                        :id="`redirect_icon${index}`"
                        v-model="redirect.icon"
                        :options="iconOptions"
                      >
                        <template #option="{label}">
                          <font-awesome-icon 
                          style="font-size: 18px" :icon="`fa-solid ${label}`" />
                        </template>
                        <template #selected-option="{label}">
                          <font-awesome-icon 
                          style="font-size: 18px" :icon="`fa-solid ${label}`" />
                        </template>
                      </v-select>
                    </b-form-group>
                  </b-col>
                  <b-col cols="12" md="3">
                    <b-form-group
                      label="標題："
                      :label-for="`redirect_title${index}`"
                      label-cols-md="3"
                    >
                      <b-form-input
                        :id="`redirect_title${index}`"
                        v-model="redirect.title"
                      />
                    </b-form-group>
                  </b-col>
                  <b-col cols="12" md="6">
                    <b-row>
                      <!-- item_description -->
                      <b-col cols="12">
                        <b-form-group
                          label="外部連結："
                          :label-for="`redirect_URL${index}`"
                          label-cols-md="3"
                        >
                          <b-form-input
                            :id="`redirect_URL${index}`"
                            v-model="redirect.url"
                          />
                        </b-form-group>
                      </b-col>
                    </b-row>
                  </b-col>
                </b-row>
                <div
                  class="d-flex flex-column justify-content-between py-50 px-25"
                >
                  <feather-icon
                    size="16"
                    icon="PlusIcon"
                    class="cursor-pointer text-success"
                    @click="addItem('contents',index)"
                    v-if="ability.can('create', 'settings_redirect_url')"
                  />
                  <feather-icon
                    size="16"
                    icon="XIcon"
                    class="cursor-pointer text-danger"
                    @click="removeItem('contents', index, redirect.id)"
                    v-if="ability.can('delete', 'settings_redirect_url')"
                  />
                </div>
              </b-col>
            </b-row>
          </div>

          <div class="d-flex mt-1 flex-wrap flex-lg-nowrap justify-content-end">
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="primary"
              class="mr-sm-2 mobile-w100"
              type="submit"
              v-if="ability.can('update', 'settings_redirect_url')"
            >
              <feather-icon size="16" class="mr-1" icon="CheckCircleIcon" />
              提交
            </b-button>
            <b-button
              v-ripple.400="'rgba(186, 191, 199, 0.15)'"
              type="button"
              variant="outline-secondary"
              @click="reset"
              class="mt-1 mt-sm-0 mobile-w100"
            >
              重置
            </b-button>
          </div>
        </b-form>
      </b-overlay>
    </validation-observer>
  </div>
</template>

<script>
import {
  BRow,
  BCol,
  BForm,
  BFormFile,
  BFormGroup,
  BFormInput,
  BFormInvalidFeedback,
  BFormCheckbox,
  BFormRadioGroup,
  BFormRadio,
  BButton,
  BOverlay,
  BFormTextarea,
  BInputGroup,
  BLink,
} from "bootstrap-vue";
import { ref, watch } from "@vue/composition-api";
import store from "@/store";
import Ripple from "vue-ripple-directive";
import "animate.css";
import { ValidationProvider, ValidationObserver, localize } from "vee-validate";
import zh_CN from "vee-validate/dist/locale/zh_CN.json";
localize("zh_cn", zh_CN);
import formValidation from "@core/comp-functions/forms/form-validation";
import { required } from "@validations";
import vSelect from "vue-select";
import { EventBus } from '@/main'
import ability from "@/libs/acl/ability";

export default {
  data() {
    return {
      required,
      ability
    };
  },
  directives: {
    Ripple,
  },
  components: {
    BForm,
    BFormGroup,
    BFormInput,
    BFormFile,
    BFormInvalidFeedback,
    BFormCheckbox,
    BFormRadioGroup,
    BFormRadio,
    BRow,
    BCol,
    BButton,
    BOverlay,
    BFormTextarea,
    BInputGroup,
    BLink,
    ValidationProvider,
    ValidationObserver,
    vSelect,
  },
  methods: {
    addItem(key, index) {
      this.newRedirectUrlData[key].splice(index + 1, 0,
        JSON.parse(
          JSON.stringify({
            id: 0,
            icon: 'fa-diamond-turn-right',
            url: '',
          })
        )
      );
    },
    removeItem(key, index, id) {
      // check number of record
      let record =
        this.newRedirectUrlData &&
        this.newRedirectUrlData[key] &&
        this.newRedirectUrlData[key].length;
      if (record <= 1) {
        this.makeToast("danger", "Warning", "請至少留有一個表單。");
      } else {
        this.newRedirectUrlData[key].splice(index, 1);
      }
    },
    reset() {
      this.$emit('refetch-data');
    },
    checkVaild() {
      var valid = false;
      this.newRedirectUrlData.contents.forEach(item => {
        if (item.url && item.icon) {
          valid = true;
        }else{
          valid = false;
        }
      });
      return valid;
    },
    onSubmit() {
      if (!this.checkVaild()) {
        this.makeToast("danger", "Warning", "請填寫所有欄位。");
        return;
      }

      this.newRedirectUrlData.contents.forEach(item => {
        if (item.url.indexOf('http') === -1) {
          item.url = 'https://' + item.url;
        }
      });

      this.newRedirectUrlData.value = JSON.stringify(
        this.newRedirectUrlData.contents
      );
      this.$swal({
        title: "你確定嗎?",
        showCancelButton: true,
        confirmButtonText: "提交",
        cancelButtonText: "取消",
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-danger ml-1",
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          this.loading = true;
          store
            .dispatch("app/editSettingInfo", this.newRedirectUrlData)
            .then((response) => {
              this.loading = false;
              this.$swal({
                text: response.data.message,
                icon: "success",
                confirmButtonText: "確定",
                customClass: {
                  confirmButton: "btn btn-primary",
                },
                showClass: {
                  popup: "animate__animated animate__bounceIn",
                },
                buttonsStyling: false,
              });
              EventBus.$emit('redirectUrlSaved')
            })
            .catch((error) => {
              this.loading = false;
              this.$swal({
                text: error.response.data.message,
                icon: "error",
                confirmButtonText: "確定",
                customClass: {
                  confirmButton: "btn btn-primary",
                },
                showClass: {
                  popup: "animate__animated animate__bounceIn",
                },
                buttonsStyling: false,
              });
            });
        }
      });
    },
    makeToast(variant = null, title = null, content = null) {
      this.$bvToast.toast(content, {
        title: title,
        variant,
        solid: true,
      });
    },
  },
  props: {
    loading: {
      type: Boolean,
      required: true,
      default: false,
    },
    redirectUrlData: {
      type: Object,
      required: true,
    },
  },

  setup(props, { emit }) {
    const newRedirectUrlData = ref({ id: 2, value: '', contents: [{ id: 0, icon: 'fa-diamond-turn-right', url: '' }] });
    const iconOptions = ref([
          'fa-diamond-turn-right',
          'fa-arrows-rotate',
          'fa-bell',
          'fa-building-columns',
          'fa-calculator',
          'fa-calendar',
          'fa-cart-shopping',
          'fa-chart-simple',
          'fa-circle-check',
          'fa-circle-info',
          'fa-circle-xmark',
          'fa-clock',
          'fa-clock-rotate-left',
          'fa-cloud-arrow-up',
          'fa-comments',
          'fa-credit-card',
          'fa-envelope',
          'fa-file',
          'fa-file-invoice',
          'fa-file-invoice-dollar',
          'fa-file-lines',
          'fa-folder',
          'fa-gear',
          'fa-hand-holding-dollar',
          'fa-id-card',
          'fa-info',
          'fa-laptop-house',
          'fa-list-check',
          'fa-location-dot',
          'fa-message',
          'fa-money-check-dollar',
          'fa-pen',
          'fa-pen-to-square',
          'fa-people-carry-box',
          'fa-person',
          'fa-person-digging',
          'fa-person-running',
          'fa-phone',
          'fa-plus',
          'fa-receipt',
          'fa-right-from-bracket',
          'fa-star',
          'fa-table-cells-large',
          'fa-ticket',
          'fa-timeline',
          'fa-times',
          'fa-trash',
          'fa-truck-field',
          'fa-user',
          'fa-user-clock',
          'fa-users',
          'fa-user-tie',
        ]
    );

    watch(
      () => props.redirectUrlData,
      (newVal) => {
        newRedirectUrlData.value = { ...newVal };
      }
    );
    const resetRedirectUrlData = () => {
      newRedirectUrlData.value = JSON.parse(
        JSON.stringify({
          id: 2,
          value: '',
          contents: [{ 
            id: 0,
            icon: 'fa-diamond-turn-right',
            url: '',
          }],
        })
      );
    };

    const { refFormObserver, getValidationState, resetForm } =
      formValidation(resetRedirectUrlData);

    return {
      refFormObserver,
      getValidationState,
      resetForm,
      newRedirectUrlData,
      iconOptions,
    };
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>


